import { useState, useContext } from 'react'
import styled from '@emotion/styled'
import { Box, Flex, Text } from 'rebass'
import { Theme } from '../../styles/settings/theme'
import { MediaQueries as Mq } from '../../styles/settings/theme'
import Arrows from '../atoms/Arrows'
import { DataContext } from '../../contexts/dataContext'
import ConnectionGroup from '../molecules/ConnectionGroup'
import { lang } from '../../utils/lang'
import { TransparentButton } from '../atoms/Buttons'
import { CgShare } from 'react-icons/cg'
import { CopyToClipboard } from 'react-copy-to-clipboard'

const LegendContainer = styled(Box)`
  width: 100%;
  position: absolute;
  top: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 0rem 0rem 0.4rem 1.25rem;
  display: ${(props) => (props.intro === 'open' ? 'none' : 'block')};
  transform: ${(props) =>
    props.show
      ? 'translateY(0rem)'
      : props.ui === 'en'
      ? 'translateY(-7.35rem)'
      : 'translateY(-7.5rem)'}; //to compensate for farsi descenders
  transition: all 0.5s ease;
  z-index: 8;
  ${Mq.xs} {
    width: auto;
    padding: 0rem 0rem 0.75rem 1.25rem;
    transform: translateY(0);
  }
`
const Line = styled(Box)`
  ${Mq.xs} {
    border-top: 1px solid ${(props) => props.theme.colors.white};
  }
`

const Dot = styled(Box)`
  width: 0.8rem;
  height: 0.8rem;
  border-radius: 50%;
`
const Item = styled(Text)`
  font-family: ${(props) => props.theme.fonts.condensed};
  font-size: 0.9rem;
  font-weight: 700;
`
const Directive = styled(Text)`
  font-family: ${(props) => props.theme.fonts.condensed};
  font-size: 0.9rem;
  font-weight: 400;
  ${Mq.xs} {
    width: 9rem;
  }
`

const MobileDirections = styled(Text)`
  font-family: ${(props) => props.theme.fonts.condensed};
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  padding-top: ${(props) => (props.ui === 'en' ? '0.1rem' : '.25rem')};
  padding-bottom: 0.2rem;
  letter-spacing: 1.4px;
  z-index: 3;
  display: block;
  cursor: pointer;
  ${Mq.xs} {
    display: none;
  }
`

const DrawerKnob = styled(Flex)`
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.6);
  box-shadow: 0 3px 20px 0 rgba(0, 0, 0, 0.71);
  border-radius: 50%;
  width: 2.25rem;
  height: 2.25rem;
  transform: translateY(1.5rem) rotate(90deg);
  margin-top: -2.2rem;
  margin-left: -1.25rem;
  padding: ${(props) =>
    props.ui === 'en' ? '0.1rem 0 0 0.9rem' : '0.1rem .4rem 0 0.9rem'};
  display: block;
  cursor: pointer;
  ${Mq.xs} {
    display: none;
  }
`

const NonMobileBox = styled(Box)`
  display: none;
  ${Mq.xs} {
    display: block;
  }
`

const Legend = () => {
  const { ui, intro } = useContext(DataContext)
  const dir = ui === 'en' ? 'ltr' : 'rtl'
  const [showLegend, setShowLegend] = useState(false)
  return (
    <LegendContainer
      intro={intro}
      show={showLegend}
      onClick={() => setShowLegend(!showLegend)}
      dir={dir}
      ui={ui}
    >
      <ConnectionGroup sm={true} />
      <Line mt={5} mb={3} />
      <Flex
        alignItems="center"
        justifyContent="flex-start"
        pr={ui === 'fa' ? '1rem' : 0}
      >
        <Dot
          bg={Theme.colors.red}
          my={2}
          mr={ui === 'en' ? 3 : 0}
          ml={ui === 'en' ? 0 : 3}
        />
        <Item>{lang[ui]['EJK']}</Item>
      </Flex>
      <Flex
        alignItems="center"
        justifyContent="flex-start"
        pr={ui === 'fa' ? '1rem' : 0}
      >
        <Dot
          bg={Theme.colors.orange}
          my={2}
          mr={ui === 'en' ? 3 : 0}
          ml={ui === 'en' ? 0 : 3}
        />
        <Item>{lang[ui]['Attempts/Threats']}</Item>
      </Flex>
      <Flex justifyContent="flex-start" pr={ui === 'fa' ? '1rem' : 0}>
        <Directive>{lang[ui]['click on dot']}</Directive>
      </Flex>
      <NonMobileBox>
        <Flex justifyContent="flex-end" pr={ui === 'en' ? '.75rem' : 0}>
          <CopyToClipboard text={window.location.href}>
            <TransparentButton border="true" ui={ui} small="true">
              <Flex alignItems="center" justifyContent="space-between">
                <CgShare color="white" />
                <p>{lang[ui]['Share']}</p>
              </Flex>
            </TransparentButton>
          </CopyToClipboard>
        </Flex>
      </NonMobileBox>
      <Flex justifyContent="center">
        <MobileDirections ml={'-1.25rem'} mt={2} ui={ui}>
          {lang[ui]['how to']}
        </MobileDirections>
      </Flex>
      <Flex justifyContent="center">
        <DrawerKnob ui={ui}>
          <Arrows
            color="white"
            width=".8rem"
            height=".8rem"
            flip={showLegend}
          />
        </DrawerKnob>
      </Flex>
    </LegendContainer>
  )
}
export default Legend
